import axios from "../../helper/axios";

export function getAddressByZipcode(zipcode) {
    return axios.get(`https://viacep.com.br/ws/${zipcode}/json`)
  }